// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyB9uu0dm67LuiLuopK3HEpHa7fjvdCXyhE",
  authDomain: "smash-lab-dd724.firebaseapp.com",
  projectId: "smash-lab-dd724",
  storageBucket: "smash-lab-dd724.appspot.com",
  messagingSenderId: "392872080000",
  appId: "1:392872080000:web:b1bb06b969c81db19a2c65",
  measurementId: "G-2Q27ZSK38F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);       // ✅ export auth
export const db = getFirestore(app);    // ✅ export Firestore

// Optional: Analytics if you want
// import { getAnalytics } from "firebase/analytics";
// export const analytics = getAnalytics(app);
